export default [
  {title: '设备SN',dataIndex: 'deviceSn'},
  {title: '设备类型',dataIndex: 'deviceType',scopedSlots: { customRender: 'deviceType' }},
  {title: '错误码',dataIndex: 'errorCode'},
  {title: '错误信息',dataIndex: 'errorInfo'},
  {title: '采集方式',dataIndex: 'idInfoCollectType'},
  {title: '所属行业',dataIndex: 'industryName'},
  {title: '采集时间',dataIndex: 'operateAt'},
  {title: '支付宝酒店名称',dataIndex: 'zfbHotelProjectName'},
]
